import { Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

export const LoadingScreen = ({ label = "One moment…" }) => (
  <div className="min-h-screen bg-white flex flex-col items-center justify-center gap-5" data-testid="loading-screen">
    <motion.span
      className="w-10 h-10 rounded-full border-[3px] border-nova-bluelight border-t-nova-blue"
      animate={{ rotate: 360 }}
      transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}
    />
    <p className="text-sm font-medium text-nova-muted">{label}</p>
  </div>
);

export const ProtectedRoute = ({ children, requireOnboarded = true, requirePlatformAdmin = false }) => {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (user === false) return <Navigate to="/login" replace />;
  if (requirePlatformAdmin && !user.is_platform_admin) return <Navigate to="/dashboard" replace />;
  if (!requirePlatformAdmin && requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  if (!requirePlatformAdmin && !requireOnboarded && user.onboarded) return <Navigate to="/dashboard" replace />;
  return children;
};
